module.exports={
	"Form": "AssetClassificationEditManifest",
	"Scope": "AssetClassification-Edit",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-Edit-Identity",
				"Group": "AssetClassification-Edit-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-Edit-Details",
				"Group": "AssetClassification-Edit-Details"
			}
		},
		"AssetClassificationDetails.IDAssetClassification":
		{
			"Name": "IDAsset Classification",
			"Hash": "AssetClassification-Edit-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.GUIDAssetClassification":
		{
			"Name": "GUIDAsset Classification",
			"Hash": "AssetClassification-Edit-GUIDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetClassification-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetClassification-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetClassification-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetClassification-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-Edit-DataAudit",
				"Group": "AssetClassification-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetClassification-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetClassification-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
